import React, {Fragment, useMemo} from 'react';

import classNames from 'classnames';
import {connect} from 'react-redux';

import {useFeatureWithAnalytics} from 'components/feature';
import {Price} from 'components/price/price';
import {ApplicationStoreType} from 'desktop/store';

import {getCart, getItemsCount} from '../../store/selectors';

import s from './shippingPrice.scss';

export type PropsType = {
    shippingPrice: string;
    shippingMethod: string;
    withLineBreak?: boolean;
    itemsCount: number;
};

/**
 * Component with shipping method and shipping price for cart summary
 * @params {PropsType} props for component
 * @returns {Node} ShippingPrice component
 */
export const ShippingPrice = ({
    itemsCount,
    shippingMethod = '',
    shippingPrice = '0',
}: PropsType) => {
    const isDiscountColor = useFeatureWithAnalytics('dCartUI_discountColor', false, 'desktop');

    const storeShippingPrice = useMemo(() => {
        if (Number(shippingPrice) === 0) {
            return itemsCount > 0 ? <Price>0</Price> : 'Free';
        }
        return <Price>{shippingPrice}</Price>;
    }, [shippingPrice, itemsCount]);

    return (
        <Fragment>
            <p
                className={classNames(s.textContainer, {
                    [s.shippingUnderDiscountFlag]: isDiscountColor,
                })}
            >
                <span className={s.text}>Shipping & Handling</span>{' '}
                {shippingMethod && itemsCount > 0 && <small>{`(${shippingMethod})`}</small>}
            </p>
            <div id="summary_shipping_price">{storeShippingPrice}</div>
        </Fragment>
    );
};

/**
 * Map state to props
 * @param {ApplicationStoreType} store - redux store
 * @returns {PropsType} props
 */
const mapStateToProps = (store: ApplicationStoreType) => ({
    itemsCount: getItemsCount(store),
    shippingMethod: getCart(store).totals.shippingMethod,
    shippingPrice: getCart(store).totals.shippingPrice,
});

export const ShippingPriceConnected = connect(mapStateToProps)(ShippingPrice);
